import { DialogM } from "@common/components/alert/dialog/Dialog"
import { theme } from "@common/theme/theme"
import moment from "moment"

// GO pressed on a Sam banner left from the day before, on the live day: the
// student may have meant Sam, so they choose. The cross opens nothing.
export function showLiveTodayDialog(liveDate, { onJoinLive, onStudyWithSam }) {
    DialogM.show({
        champion: "zoe",
        variant: "main",
        text1: `Ton live, c'est aujourd'hui à ${moment(liveDate).format("HH[h]mm")}`,
        text2: "Tu le rejoins, ou tu étudies avec Sam en attendant ?",
        buttonText1: "Rejoindre mon live",
        buttonColor1: theme.colors.success,
        onPress: onJoinLive,
        buttonText3: "Étudier avec Sam",
        onPress3: onStudyWithSam,
        exitButton: true,
        onPressBack: () => {},
    })
}
